/* template */
<template minapp="mpx" xlang="wxml"><Drawer :externStyle="(customStyle)" :headerStyle="(headerStyle)" :show="(show)" showMask :showCloseBtn="(false)" @close="closeDrawer" v-if="(!repeat)"><div :class="({'no-fee': type === 1})" :style="[(containerStyle)] | transRpxStyle" class="container"><div class="no-fee-content" v-if="(type === 1)"><div class="title">{{ worryfreeRightPopTitle }}</div><div class="sub-title">{{ serviceFee }}元/份，{{ pureDescText }}</div><div class="card-area"><div v-for="(item, index) in (worryfreeRightTipsInfo)" :class="({big: index <= 1})" :key="item.index" class="card-item"><mpx-image :src="(item.icon)" class="icon" v-if="(index > 1)"/><div class="icon-container" v-else><mpx-image :src="(item.icon)" class="icon big"/></div><div :class="({big: index <= 1})" class="desc-area"><div :class="({big: index <= 1})" class="desc" v-if="(item.title)">{{
                item.title
              }}</div><div :class="({big: index <= 1})" class="sub-desc" v-if="(item.subhead)">{{
                item.subhead
              }}</div></div></div></div></div><div class="have-fee-content" v-else><div class="train-info"><div class="train-station">{{ startStation }}<spring-icon w="34" h="12" name="half-right-arrow" class="arrow"/>{{
              endStation
            }}</div><div class="train-normal"><div class="info-item">{{ trainNo }}</div><div class="info-item left-pipe">{{ startTime }}</div><div class="info-item left-pipe">{{ seatType }}</div></div><div class="profit-passgenger"><div class="info-item profit right-pipe">退改费用最高¥{{ refundChangePrice }}元</div><div class="info-item passenger">{{ passengerName }}</div></div></div><div class="profit-card"><div class="content"><div class="header"><hlText :text="(hlDescText)" color="#333" hlColor="#FF6400" class="hl-desc"></hlText><div class="fee">{{ serviceFee }}元/份</div></div><div class="focused"><div v-for="(item, index) in (worryfreeRightTipsInfo.slice(0,2))" :key="item.index" class="focused-item"><mpx-image :src="(item.icon)" class="icon" v-if="(item.icon)"/><div class="desc"><div class="title" v-if="(item.title)">{{ item.title }}</div><div class="sub-title" v-if="(item.subhead)">{{ item.subhead }}</div></div></div></div><div class="profit-list"><div v-for="(item, index) in (worryfreeRightTipsInfo.slice(2))" :key="item.index" class="profit-item"><div class="icon-container"><mpx-image :src="(item.icon)" class="icon" v-if="(item.icon)"/></div><div class="desc" v-if="(item.title)">{{ item.title }}</div></div></div></div></div></div><div class="btn-area"><Button @click="closeDrawerAndSubmit" :externClass='["btn disagree"].join(" ")'>否</Button><div class="card-button-area"><Button @click="confirm" :externClass='["btn agree"].join(" ")'>是</Button><BubbleBtn :bubbleText="(worryFreeCoupon)" class="bubble-btn" v-if="(worryFreeCoupon)"/></div></div></div></Drawer></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m610de601"}'>
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/ScJsPNeCbzw01nj7OgQuL.otf')
  .container
    position relative
    box-sizing border-box
    padding 28px 20px 38.5px 20px
    display flex
    flex-direction column
    align-items center
    &.no-fee
      padding 31px 20px 38.5px 20px
      background-image url('https://ut-static.udache.com/webx/sfc/VG5_75Y_heVhZ16WVrjpm.png')
    .no-fee-content
      width 100%
      display flex
      flex-direction column
      align-items center
      .title
        font-family MFYuanHei
        font-size 20px
        background linear-gradient(265deg, #582605 0%, #542505 12%, #963F04 29%, #532405 43%, #522405 99%)
        -webkit-background-clip text
        -webkit-text-fill-color transparent
        background-clip text
        margin-bottom 5px
      .sub-title
        position relative
        font-family PingFang SC
        font-size 12px
        font-family PingFangSC-Medium
        font-weight 500
        color #783E17
        margin-bottom 30px
        &::after, &::before
          content ''
          position absolute
          width 44px
          height 1px
          top 50%
          background linear-gradient(270deg, #522404 0%, rgba(82, 36, 4, 0) 99%)
        &::after
          left -8px
          transform translate(-100%, -50%)
        &::before
          right -8px
          transform translate(100%, -50%) rotate(180deg)
      .card-area
        width 100%
        display flex
        flex-wrap wrap
        justify-content space-between
        margin-bottom 26px
        .card-item
          width calc(((100% - 8px) / 2))
          margin-bottom 8px
          display flex
          align-items center
          border-radius 8px
          box-sizing border-box
          padding 16px 0 16px 15px
          background linear-gradient(113deg, rgba(255, 241, 232, 0.3) 7%, rgba(255, 241, 232, 0.3) 7%, rgba(255, 247, 237, 0.3) 47%, rgba(253, 240, 214, 0.3) 89%)
          &.big
            padding 23.5px 0 32.5px 0
            flex-direction column
            opacity 1
            background linear-gradient(180deg, #FFFFFF 33%, #FEFAF2 100%)
            border 0.5px solid #fbead2
            border-radius 16px
          .icon-container
            display flex
            justify-content center
            align-items center
            margin-bottom 25px
            height 55px
            width 55px
            border-radius 15px
            background linear-gradient(139deg, #FFF1E8 4%, rgba(255, 241, 232, 0.9937) 4%, rgba(255, 247, 237, 0.9967) 45%, #FDF0D6 90%)
          .icon
            height 30px
            width 30px
            margin-right 11px
            &.big
              margin-right 0
              height 40px
              width 40px
          .desc-area
            display flex
            flex-direction column
            &.big
              align-items center
            .desc
              color #333
              font-family PingFangSC-Semibold
              font-weight 600
              margin-bottom 6px
              font-size 12px
              line-height 1
              &.big
                font-size 16px
                margin-bottom 9px
            .sub-desc
              color #666
              font-family PingFangSC-Regular
              font-weight 400
              font-size 10px
              line-height 1
              &.big
                font-size 12px
    .have-fee-content
      width 100%
      display flex
      flex-direction column
      margin-bottom 18px
      .train-info
        display flex
        flex-direction column
        justify-content flex-start
        margin-bottom 10px
        .train-station
          display flex
          align-items center
          color #333
          font-size 22px
          line-height 20px
          font-family PingFangSC-Medium
          font-weight 500
          margin-bottom 14px
          .arrow
            margin 0 4px
        .left-pipe
          position relative
          margin-left 16px
          &::before
            position absolute
            content ''
            top 50%
            left -8px
            height 20px
            width 1px
            background #999
            transform scale(0.5) translateY(-100%)
        .right-pipe
          position relative
          margin-right 16px
          &::after
            position absolute
            content ''
            top 50%
            right -8px
            height 20px
            width 1px
            background #999
            transform scale(0.5) translateY(-100%)
        .passenger
          flex 1
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
        .info-item
          font-size 14px
          line-height 1
          color #333
          font-family PingFangSC-Regular
          font-weight 400
        .train-normal
          display flex
          margin-bottom 7px
          align-items center
        .profit-passgenger
          display flex
          align-items center
          .profit
            color #FF6400
            font-family PingFangSC-Medium
            font-weight 500
      .profit-card
        height 263.5px
        background-image url('https://ut-static.udache.com/webx/sfc/JAdl7PMsyEjMKwcu3LRzW.png')
        background-size 100% 100%
        background-repeat no-repeat
        margin 0 -10px
        box-sizing border-box
        padding 45.5px 3px 3px 3px
        display flex
        .content
          display flex
          flex-direction column
          width 100%
          flex 1
          border-radius 10px
          background #fff
          padding 12px 13px 25px 12px
          box-sizing border-box
          .header
            display flex
            justify-content space-between
            align-items center
            margin-bottom 12px
            .hl-desc
              font-size 12px
              font-family PingFangSC-Medium
              font-weight 500
            .fee
              font-size 11px
              line-height 10px
              color #666
              font-family PingFangSC-Regular
              font-weight 400
          .focused
            width 100%
            box-sizing border-box
            padding 20.5px 18px
            display flex
            justify-content space-between
            background linear-gradient(105deg, rgba(255, 241, 232, 0.4) 8%, rgba(255, 241, 232, 0.4) 8%, rgba(255, 247, 237, 0.4) 47%, rgba(253, 240, 214, 0.4) 89%)
            border-radius 8px
            margin-bottom 12px
            .focused-item
              display flex
              width 50%
              align-items center
              .icon
                height 33px
                width 33px
                margin-right 10px
              .desc
                display flex
                flex-direction column
                .title
                  font-size 14px
                  line-height 12px
                  font-family PingFangSC-Medium
                  font-weight 500
                  color #333
                  margin-bottom 8px
                .sub-title
                  font-size 11px
                  line-height 10px
                  color #999
                  font-family PingFangSC-Regular
                  font-weight 400
          .profit-list
            display grid
            grid-template-columns repeat(3, 1fr)
            grid-template-rows auto auto
            grid-row-gap 12px
            grid-column-gap 14px
            .profit-item
              display flex
              align-items center
              // 3的倍数的iten
              &:nth-child(3n)
                justify-content flex-end
              .icon-container
                width 28px
                height 28px
                display flex
                justify-content center
                align-items center
                border-radius 8px
                margin-right 8px
                background linear-gradient(139deg, #FFF1E8 4%, rgba(255, 241, 232, 0.9937) 4%, rgba(255, 247, 237, 0.9967) 45%, #FDF0D6 90%)
              .icon
                height 22px
                width 22px
              .desc
                font-family PingFangSC-Medium
                font-weight 500
                font-size 12px
                line-height 1
                color #333
    .btn-area
      width 100%
      display flex
      justify-content space-between
      .btn
        border-radius 8px
        box-sizing border-box
        display flex
        justify-content center
        align-items center
        font-size 16px
        padding 14px 0
      .disagree
        color #999
        font-family PingFangSC-Medium
        font-weight 500
        width 109px
        margin-right 8px
        border 1px solid #ccc
      .agree
        font-family PingFangSC-Semibold
        font-weight 600
        background #FF6400
        color #fff
        flex 1
      .card-button-area
        position relative
        flex 1
      .bubble-btn
        position absolute
        top -10px
        right 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m610de601"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ticket-retention-drawer.mpx.js?isComponent&outputPath=components%2Fticket-retention-drawer610de601%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ticket-retention-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fticket-retention-drawer610de601%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m610de601"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ticket-retention-drawer610de601/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spring-icon':getComponent(require("../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'Drawer':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-drawer/index.mpx?isComponent&outputPath=components%2Findex76c11e5c%2Findex")),'Button':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-button/index.mpx?isComponent&outputPath=components%2Findex9b0ba146%2Findex")),'hlText':getComponent(require("../../../../node_modules/@didi/spring-ui/hl-text/index.mpx?isComponent&outputPath=components%2Findex1ae4dab3%2Findex")),'BubbleBtn':getComponent(require("../../home/components/bubble-btn/index.mpx?isComponent&outputPath=components%2Findexd2aa2f48%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
